import React, { useState } from 'react'
import ErrorIcon from '@material-ui/icons/Error'
import { ErrorsDrawer } from './ErrorsDrawer'
import { useScreenSize } from 'hooks'

export type ErrorItem = {
  message: string
  title?: string
  details?: string
  actionButton?: React.ReactNode
}

type Props = {
  errors: ErrorItem[]
  drawerTitle?: string
  drawerDescription?: string
}

export const ErrorsIndicator = ({ errors, ...props }: Props) => {
  const { isMobile } = useScreenSize()
  const [open, setOpen] = useState(false)
  return (
    <>
      <ErrorsDrawer
        drawerTitle={props.drawerTitle}
        drawerDescription={props.drawerDescription}
        errors={errors}
        isOpen={open}
        onClose={() => setOpen(false)}
      />

      <button
        onClick={() => setOpen(true)}
        className="bg-mm-warning-100 text-mm-warning-800 hover:bg-mm-warning-200 inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium transition-colors"
      >
        <ErrorIcon fontSize="small" className={isMobile ? '' : 'mr-1'} />
        {!isMobile && 'View Errors'}
      </button>
    </>
  )
}
